import { render, staticRenderFns } from "./btracombi.vue?vue&type=template&id=6105b96b"
import script from "./btracombi.vue?vue&type=script&lang=js"
export * from "./btracombi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports